import React from "react"
import NumberFormat from "react-number-format"
import { Redirect } from "react-router-dom"
import { connect } from "react-redux"

import { initApp, setPlatformType } from "../../actions/appInitAct"
import { getLoggedProfile, logout } from "../../actions/sessionAct"

import { devMode } from "../../model/base"
import { getBalance } from "../../model/wallet"

import { commonErr } from "../common/errors"
import { LoadingPage } from "../common/loading"
import { TPlatformType, getPlatformAccountType, getLoginPlatform } from "../common/common"

import biz from "../../static/img/logo/business.png"
import agent from "../../static/img/logo/agency.png"


const baseBizDomain = `https://${devMode ? "dev." : ""}mioto.vn/login?redirect=http://biz${devMode ? "-dev" : ""}.mioto.vn/`
const baseAgentDomain = `https://${devMode ? "dev." : ""}mioto.vn/login?redirect=http://agent${devMode ? "-dev" : ""}.mioto.vn/`


class Header extends React.Component {
	_isMounted = false;
	
	constructor(props) {
		super(props);
		this.state = {
			err: commonErr.INNIT,
			errMsg: "",
			platformType: 0
		}

	}

	componentDidMount() {

		this._isMounted = true;
		const appInitErr = this.props.appInit.err;
		const sessionErr = this.props.session.profile.err;

		if (appInitErr === commonErr.INNIT) {
			this.props.dispatch(initApp());
		}

		if (sessionErr === commonErr.INNIT) {
			this.props.dispatch(getLoggedProfile());
		} 
		
		getBalance().then((resp) => {
			if (this._isMounted) {
				if ( resp.data.error === commonErr.SUCCESS) {
					this.setState({
							balance: resp.data.data.balance
					})
				} else {
						this.setState({
								err: resp.data.error,
						})
				}
			}
		})
		
		const url = window.location.hostname;
		let platformType = getLoginPlatform(url); 
		
		this.props.dispatch(setPlatformType(platformType))
	}

	

	componentWillUnmount() {
    this._isMounted = false;
	}
	
	logout = () => {
		
		const url = window.location.hostname;

		this.props.dispatch(logout());

		if (getLoginPlatform(url) === TPlatformType.BIZ) { 
			window.location.assign(baseBizDomain)
		} else {
			window.location.assign(baseAgentDomain)
		}
	}

	render() {
		let content;
		const url = window.location.hostname;
		const err = this.props.session.profile.err;
		const profile = this.props.session.profile;
		const info = this.props.session.profile.info;
	

		if (err === commonErr.INNIT || err === commonErr.LOADING) {
				content = <LoadingPage />
		} else if (err === commonErr.SUCCESS) {

			let platformType = getPlatformAccountType(profile.info, url)

			if (profile && platformType === TPlatformType.BIZ) {
				
					content = <div className="flexbox flex-1"> 
						<ul className="nav navbar-toolbar">
							<li><a className="nav-link sidebar-toggler js-sidebar-toggler" href="javascript:;"><span className="icon-bar" /><span className="icon-bar" /><span className="icon-bar" /></a></li>
						</ul>
				
						<ul className="nav navbar-toolbar">
							<li><a className="nav-link quick-sidebar-toggler font-14" href="/mywallet"><i className="ti-wallet font-18 mr-1" /><span className="userName">Số dư: <span className="font-strong"><NumberFormat value={this.state.balance} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></span></span></a></li>
							<li className="dropdown dropdown-user"><a className="nav-link dropdown-toggle link"><span className="userName">{info.name}</span><img src={(info.avatar && info.avatar.thumbUrl) ? info.avatar.thumbUrl : ""} alt="image" /></a>
							</li>
							<li><a className="nav-link quick-sidebar-toggler" onClick={this.logout}><i className="ic ic-logout" /></a></li>
						</ul>
					</div>
				 } else if (profile && platformType === TPlatformType.AGENT) {
					content = <div className="flexbox flex-1"> 

					<ul className="nav navbar-toolbar">
						<li><a className="nav-link sidebar-toggler js-sidebar-toggler" href="javascript:;"><span className="icon-bar" /><span className="icon-bar" /><span className="icon-bar" /></a></li>
					</ul>
				
					<ul className="nav navbar-toolbar">
						<li><a className="nav-link quick-sidebar-toggler font-14" href="/mywallet"><i className="ti-wallet font-18 mr-1" /><span className="userName">Số dư: <span className="font-strong"><NumberFormat value={this.state.balance} displayType={'text'} thousandSeparator={" "} decimalSeparator={","} suffix={"đ"} /></span></span></a></li>
						<li className="dropdown dropdown-user"><a className="nav-link dropdown-toggle link"><span className="userName">{info.name}</span><img src={(info.avatar && info.avatar.thumbUrl) ? info.avatar.thumbUrl : ""} alt="image" /></a>
						</li>
						<li><a className="nav-link" onClick={this.logout}><i className="ic ic-logout" /></a></li>
					</ul>
				
					</div>
				 } else {
					 content = <Redirect to="/error" />
				 }

			} else  {

				if (getLoginPlatform(url) === TPlatformType.BIZ) { 
						window.location.assign(baseBizDomain)
				} else {
						window.location.assign(baseAgentDomain)
			}
			
		} 
	
		return <header className="header">
						<div className="page-brand">
							<div className="brand">
								<div className="logocover">
									<img src={getLoginPlatform(url) === TPlatformType.AGENT ? agent : biz} />
								</div>
							</div>
						</div>
						{content}
					</header>
	}
}
function mapInitState(state) {
	return {
			appInit: state.appInit
	}
}

function mapState(state) {
	return {
			session: state.session
	}
}

Header = connect(mapInitState)(Header);
Header = connect(mapState)(Header);

export default Header


// WEBPACK FOOTER //
// ./src/components/common/header.js